import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from "../../../service/auth.service";
import {ProgressSpinner} from "primeng/progressspinner";

@Component({
  selector: 'app-callback-component',
  templateUrl: './callback-component.component.html',
  imports: [
    ProgressSpinner
  ],
  styleUrls: ['./callback-component.component.scss']
})
export class CallbackComponentComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {

  }

  async ngOnInit(): Promise<void> {
    try {
      await this.auth.oauthService.loadDiscoveryDocument();
      await this.auth.oauthService.tryLoginCodeFlow();
      if (!this.auth.oauthService.hasValidAccessToken()) {
        throw new Error('No valid access token found');
      }
      this.auth.handlePostLogin();
    } catch (error) {
      this.router.navigate(['/login'], {
        state: {
          code: 'CALLBACK_FAILED',
          message: error instanceof Error ? error.message : 'Unknown authentication error',
          timestamp: new Date().toISOString()
        }
      });
    }
  }
}
